<template>
  <div>
    <div class="freeback-container">
      <div class="freeback-img-box">
        <img src="@assets/pc/images/freeback.png" />
      </div>
      <div class="freeback-box-border">
        <div class="freeback-box">
          <div class="freeback-title">
            <h1>意见反馈</h1>
            <h2>感谢你的反馈，我们会积极改善，做出更好的服务的</h2>
          </div>
          <div class="freeback-content">
            <div class="freeback-form">
              <Form :model="formItem" :label-width="80">
                <FormItem label="标题">
                  <i-input
                    v-model="formItem.title"
                    placeholder="请输入标题"
                  ></i-input>
                </FormItem>
                <FormItem label="邮箱账号">
                  <i-input
                    v-model="formItem.email"
                    placeholder="方便留下您的信息，以便我们更好回复您"
                  ></i-input>
                </FormItem>
                <FormItem label="反馈信息">
                  <i-input
                    v-model="formItem.message"
                    type="textarea"
                    :autosize="{ minRows: 8, maxRows: 10 }"
                    placeholder="请输入反馈信息"
                  ></i-input>
                </FormItem>
                <FormItem>
                  <Button type="primary" @click="commitForm">提交</Button>
                  <Button type="ghost">清空信息</Button>
                </FormItem>
                <Spin size="large" fix v-if="loading"></Spin>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { feedBack } from "@api/user";
export default {
  name: "Freeback",
  data() {
    return {
      formItem: {
        title: "",
        message: "",
        email: ""
      },
      loading: false
    };
  },
  methods: {
    commitForm() {
      if (this.formItem.title.length > 0 && this.formItem.message.length > 0) {
        this.loading = true;
        feedBack(this.formItem).then(res => {
          this.loading = false;
          this.$Message.success(res.msg);
        });
      } else {
        this.$Message.error("标题和反馈内容不能为空");
      }
    }
  }
};
</script>

<style scoped>
.freeback-container {
  margin: 15px auto;
  width: 80%;
  height: 600px;
  display: flex;
  align-items: center;
  /* background-color: #ccc; */
}
.freeback-img-box {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.freeback-img-box img {
  width: 80%;
}
.freeback-box-border {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.freeback-box {
  width: 480px;
}
.freeback-content {
  margin: 15px auto;
  border: 1px #ccc dotted;
  position: relative;
}
.freeback-form {
  margin: 30px auto;
  width: 90%;
}
</style>
